import { FC } from 'react';
import ManageTokens from 'components/document-templates/components/ManageTokens';

const Screen: FC = () => {
  return (
    <ManageTokens
      tokensEntityName="client-tokens"
      tokensEndpoint="client-tokens"
      fieldsEntityName="client-fields"
      fieldsEndpoint="client-fields"
      tokenIdKey="client_token_id"
      fieldIdKey="client_field_id"
      templateFilter="client_template_id"
    />
  );
};

export default Screen;
